/* Ayudate · Extensiones de archivo permitidas para fotos y comprobantes */

export const EXTENSIONES_IMAGEN_PERMITIDAS = ["jpg", "jpeg", "png", "webp"];
export const FORMATOS_IMAGEN_TEXTO = "JPG, JPEG, PNG o WEBP";

function extensionDe(archivo) {
  const nombre = archivo?.name || "";
  const punto = nombre.lastIndexOf(".");
  return punto === -1 ? "" : nombre.slice(punto + 1).toLowerCase();
}

/* Se valida por extensión del nombre, no solo por MIME: así se rechaza al
   toque un .pdf o .heic renombrado, sin esperar a que el navegador intente
   decodificarlo como imagen. */
export function validarExtensionImagen(archivo) {
  const ext = extensionDe(archivo);
  if (!ext || !EXTENSIONES_IMAGEN_PERMITIDAS.includes(ext)) {
    throw new Error(
      `Formato ".${ext || "desconocido"}" no permitido. Solo se aceptan imágenes en `
      + `${FORMATOS_IMAGEN_TEXTO}.`
    );
  }
}
